import DeviceWidget from "../../FormComponents/DeviceWidget/DeviceWidget";
import {Trans} from "../../utils/i18n";
import React from "react";


export const addressConfigB2bAutocomplete = [
    {
        "name": "name",
        "label": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
        "size": "full",
        "type": "text",
        "required": true,
    },
    {
        "name": "address2",
        "label": "Address Info",
        "size": "full",
        "type": "text",
    },
    {
        "name": "email",
        "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "size": "half",
        "type": "email",
    },
    {
        "name": "phone",
        "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
        "size": "half",
        "type": "text",
    },
    {
        "size": "full",
        "component": "addressautocomplete"
    },
    // {
    //     "name": "street",
    //     "label": <Trans i18nKey="orderEntry.addressContact.streetHouse">Street, house number</Trans>,
    //     "size": "half",
    //     "required": true,
    // },
    {
        "name": "zip",
        "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
        "size": "half",
        "required": true,
    },
    {
        "name": "city",
        "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
        "size": "half",
        "required": true,
    },
    {
        "name": "country_id",
        "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
        "size": "half",
        "type": "select",
        "options": [
            {
                "value": "de",
                "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
            },
            {
                "value": "ch",
                "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
            }
        ],
        "required": true,
    },
];

export const addressConfigB2b = [
    {
        "size": "full",
        "component": "addressselect"
    },
    {
        "name": "name",
        "label": <Trans i18nKey="orderEntry.addressContact.company_name">Company name</Trans>,
        "size": "full",
        "type": "text",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "address2",
        "label": <Trans i18nKey="orderEntry.addressContact.address2">Address 2</Trans>,
        "size": "full",
        "type": "text",
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "street",
        "label": <Trans i18nKey="orderEntry.addressContact.street">Street</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "housenumber",
        "label": <Trans i18nKey="orderEntry.addressContact.housenumber">House number</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "zip",
        "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "city",
        "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "state",
        "label": <Trans i18nKey="orderEntry.addressContact.province">Province</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'IT' && (values.company_id || orderEntryState?.serialNumber?.order?.company_id),
    },
    {
        "name": "country_id",
        "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
        "size": "half",
        "type": "select",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "email",
        "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "size": "half",
        "type": "email",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
    {
        "name": "phone",
        "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
        "size": "half",
        "type": "phoneinput",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.company_id || orderEntryState?.serialNumber?.order?.company_id,
        "disabledFunction": values => !values.custom_address,
    },
]
